export const Pod = {
  PROVIDER: 'provider',
  CONSUMER: 'consumer',
  OPS: 'ops',
  GROWTH: 'growth',
  PLATFORM: 'platform',
  CARE_EXPANSION: 'care-expansion',
  PROVIDER_QUALITY: 'provider-quality',
  MEDICAL: 'medical',
} as const;

export type Pod = (typeof Pod)[keyof typeof Pod];

export const PodToIncidentTeamId: Record<Pod, string> = {
  [Pod.PROVIDER]: '01K5SAP265WB5CV4X0KQ70SJ3X',
  [Pod.CONSUMER]: '01K5YRBKTSZK7TQ4FNGCYT6R8J',
  [Pod.OPS]: '01JXDNRCW91CJXSATX6H2R6BGP',
  [Pod.GROWTH]: '01K5S5VNE679FA5N5SRAPVDDED',
  [Pod.PLATFORM]: '01K5YRCKCQDRP840J1313AWWHK',
  [Pod.CARE_EXPANSION]: '01KK2BBQ48NY2Q2G88CEXJMEDN',
  // Provider Quality shares the Provider pod's incident.io on-call rotation.
  [Pod.PROVIDER_QUALITY]: '01K5SAP265WB5CV4X0KQ70SJ3X',
  [Pod.MEDICAL]: '01KK2BBQ48NY2Q2G88CEXJMEDN', // formerly known as care-expansion
};
